import { PrintedDocument } from '@/api/model/printed-document'
import { RootState } from '@/store'
import { Module } from 'vuex'
import { actions } from '@/store/printedDocuments/actions'
import { mutations } from '@/store/printedDocuments/mutations'
import { getters } from '@/store/printedDocuments/getters'

export interface PrintedDocumentState {
    loading: boolean,
    error: string|null,
    printedDocuments: PrintedDocument[],
    totalItems: number,
    totalPages: number,
    page: number,
    itemsPerPage: number,
    orderField: string|null,
    orderDirection: string|null,
    companyFilter: string|null,
}

const state: PrintedDocumentState = {
    loading: false,
    error: null,
    printedDocuments: [],
    totalItems: 0,
    totalPages: 0,
    page: 1,
    itemsPerPage: 10,
    orderField: 'updatedAt',
    orderDirection: 'desc',
    companyFilter: null,
}

export const PrintedDocumentModule: Module<PrintedDocumentState, RootState> = {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
}
